<template>
	<card class=" guideline-job-list">
		<template v-if="jobList.length < 1">
			<div class="empty-list tw-flex tw-justify-center tw-items-center tw-w-full">
				<div class="empty-job-card"></div>
				<p class="tw-text-center">Agrega todos los puestos de TRABAJO DE  tu empresa</p>
			</div>
		</template>
		<template v-if="jobList.length > 0">
			<div class="tw-flex tw-flex-wrap tw--mx-3">
				<div
					v-for="(job) in jobList"
					:key="job.name"
					class="tw-w-1/3 tw-px-3 tw-mb-6"
				>
					<guideline-model-job-item
						:job="job"
						:completed="job.completed"
						:selected="selectedJob.name === job.name"
						@deleteClick="$emit('deleteClick', $event)"
						@editionClick="$emit('editionClick', $event)"
					/>
				</div>
			</div>
		</template>
	</card>
</template>

<script>
import GuidelineModelJobItem from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-list/guideline-model-job-item';
import Card from '@/modules/shared/components/ui/Card/Card';

export default {
	name: 'guideline-job-list',
	components: { Card, GuidelineModelJobItem },
	props: ['jobList', 'selectedJob'],
};
</script>

<style lang='scss' scoped>
 .guideline-job-list {
	 min-height: 450px;
	 .empty-list {
		 position: relative;
		 min-height: 450px;
		 .empty-job-card {
			 position: absolute;
			 padding: inherit;
			 top: 0;
			 left: 0;
			 width: 30%;
			 height: 30%;
			 border: 2px dashed #9b9b9b;
			 border-radius: 10px;
		 }
		 p {
			 text-transform: uppercase;
			 color: #9b9b9b;
			 width: 200px;
		 }
	 }
 }
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-list/guideline-job-list.vue